import React, { useState } from 'react';

const FAQItem = ({ question, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="mb-4 bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <button
                className="w-full flex justify-between items-center p-6 text-left focus:outline-none"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="text-base font-semibold text-[#001C3D]">{question}</span>
                <svg
                    className={`w-6 h-6 text-[#001C3D] transform transition-transform ${isOpen ? 'rotate-45' : ''}`}
                    viewBox="0 0 24 24"
                >
                    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
            </button>

            {isOpen && (
                <div className="px-6 pb-6 text-gray-600 text-sm">
                    {children}
                </div>
            )}
        </div>
    );
};

const FAQSection = () => {
    return (
        <div className="py-12">
            <h2 className="text-2xl font-bold text-[#001C3D] text-center mb-8">
                How can we help you?
            </h2>

            <FAQItem question="What are my subscription benefits?">
                <p className="mb-3">Your subscription gives you full access to:</p>
                <ul className="space-y-4">
                    <li>
                        <strong className="block text-[#001C3D]">Verified Safe Spots</strong>
                        <div className="mt-1">272K+ curated gluten-free restaurants, bakeries, and cafes</div>
                    </li>
                    <li>
                        <strong className="block text-[#001C3D]">Safety Ratings</strong>
                        <div className="mt-1">Detailed celiac-safety ratings for each location</div>
                    </li>
                    <li>
                        <strong className="block text-[#001C3D]">Community Reviews</strong>
                        <div className="mt-1">Real experiences from people just like you</div>
                    </li>
                    <li>
                        <strong className="block text-[#001C3D]">Location Features</strong>
                        <div className="mt-1">Find safe spots anywhere you go, save favorites, and get directions</div>
                    </li>
                </ul>
            </FAQItem>

            <FAQItem question="My payment failed :(">
                <p className="mb-3">Don&apos;t worry! Here&apos;s what you can do:</p>
                <ol className="list-decimal pl-5 space-y-4">
                    <li>Check if your card has sufficient funds</li>
                    <li>Verify that your card details are entered correctly</li>
                    <li>Try using a different payment method</li>
                    <li>
                        If you&apos;re still having issues, contact us at <a href="mailto:support@atly.com" className="text-[#F01E6F] font-medium">support@atly.com</a> and we&apos;ll help you out
                    </li>
                </ol>
            </FAQItem>

            <FAQItem question="How do I cancel my subscription?">
                <p className="mb-3">It&apos;s sad to see you go. Here&apos;s how you can cancel your subscription:</p>
                <ol className="list-decimal pl-5 space-y-4">
                    <li>
                        If you subscribed through the App Store:
                        <div className="mt-1 ml-1">go to Settings {'>'}  Your Name {'>'} Subscriptions to manage your subscriptions</div>
                    </li>
                    <li>
                        If you subscribed through Google Play:
                        <div className="mt-1 ml-1">go to Google Play Store {'>'} Profile {'>'} Payments & Subscriptions {'>'} Subscriptions</div>
                    </li>
                    <li>
                        If you subscribed through the website:
                        <div className="mt-1 ml-1">contact our amazing support team at <a href="mailto:support@atly.com" className="text-[#F01E6F] font-medium">support@atly.com</a> and submit your request</div>
                    </li>
                </ol>
            </FAQItem>

            <div className="text-center mt-12 text-blue-950">
                <p className=" mb-2">Need more information?</p>
                <p>
                    Don&apos;t hesitate to contact us at <br />
                    <a href="mailto:support@atly.com" className="text-[#F01E6F] underline">
                        support@atly.com
                    </a>
                </p>
            </div>
        </div>
    );
};

export default FAQSection; 